<template>
  <div class="center-outter">
    <div>
      <leftArea></leftArea>
    </div>
    <div style="margin-bottom: 110px;">
      <centerArea></centerArea>
    </div>
    <div>
      <rightArea></rightArea>
    </div>
  </div>
</template>

<script>
import centerArea from './components/centerArea.vue'
import leftArea from './components/leftArea.vue'
import rightArea from './components/rightArea.vue'

export default {
    components: {
        centerArea,
        leftArea,
        rightArea
    }
}
</script>

<style scoped>
.center-outter {
  box-sizing: border-box;
  width: 1920px;
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 80px;
}
</style>